










































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import DateComponent from "@/components/common/Inputs/Date.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import { Action } from "vuex-class";
import { Locales } from "@/i18n/locales";
@Component({
  components: {
    DateComponent,
  },
})
export default class CreateArchive extends Vue {
  @Action("showNotification", { namespace: "application" })
  showNotification: any;
  snackbar: boolean = false;
  message: string = "";
  snackBarColor: string = "red";
  StartDate: string = "";
  EndDate: string = "";
  data: any = {};
  date: any = {
    startDate: "",
    EndDate: "",
  };
  items = _app.archiveCreateHeaders;
  disable = true;
  showSave = false;
  showEdit = true;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  get getData() {
    return utils.formatCurrency(this.data.Budget, null, this.defaultLocale);         
  }

  save() {
    if (
      (this.$refs.Archiveform as Vue & { validate: () => boolean }).validate()
    ) {
      if (this.data.ShowPublic == true) {
        this.data.ShowPublic = 1;
      } else {
        this.data.ShowPublic = 0;
      }
      this.$services.archive.createArchive(this.data).then((resp) => {
        if (resp.Result == "OK") {
          this.showNotification({
            text: this.$t(resp.Message),
            isHtml: true,
            color: "success",
          });
          this.$router.push({
            name: "UpdateArchiveComponent",
            params: { archiveId: resp.Record[0].ArchiveCallId },
          });
        } else {
          this.showNotification({
          text: this.$t("Failed to create data"),
          isHtml: true,
          color: "error",
        });
        }
      });
    }
  }
  edit() {}
  close() {
    this.$router.push({
      name: "ArchiveComponent",
    });
  }
  updateDate(date) {
    let formattedDate = this.formatDate(date);
    date = formattedDate;
  }
  formatDate(date: any) {
    return date ? utils.formatDate(date) : "";
  }
  mounted() {
    this.items.map((x) => {
      x.text = this.$t(x.text);
    });

    this.$services.archive.getCurrencies().then((data) => {
      if (data.Result == "OK") {
        this.items.find((x) => this.$t(x.text) == this.$t("Budget Currency")).items = data.Record;
      }
    });

    this.$services.archive.getProgrammes().then((data) => {
      if (data.Result == "OK") {
        this.items.find((x) => x.text == "Programme").items = data.Record;
      }
    });
  }
}
